import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistStore, persistReducer } from "redux-persist";
import storeReducer from "./rootStore";

const rootReducers = combineReducers({
  rootStore: storeReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["rootStore"], // Keys to persist
  // whitelist: ['auth'], // Keys to persist
};

const persistedReducer = persistReducer(persistConfig, rootReducers);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Needed for redux-persist
    }),
});

const persistor = persistStore(store);

export default store;
export { persistor };
